import { render, staticRenderFns } from "./EditScolariteFeesModal.vue?vue&type=template&id=635c5ee3&scoped=true&"
import script from "./EditScolariteFeesModal.vue?vue&type=script&lang=js&"
export * from "./EditScolariteFeesModal.vue?vue&type=script&lang=js&"
import style0 from "./EditScolariteFeesModal.vue?vue&type=style&index=0&id=635c5ee3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c5ee3",
  null
  
)

export default component.exports